import React from "react";
import { useSelector } from "react-redux";
import ShowBill from "../components/ShowBill";
import ShowCart from "../components/ShowCart";

export default function CartPage() {
  const productList = useSelector((state) => state);
  const counterState = useSelector((state) => state);

  const totalCart = counterState.reduce(
    (prevTotal, state) => state.totalOrder + prevTotal,
    0
  );

  return (
    <div className="container 2xl:px-8 px-2 mx-auto">
      <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
      <div className="cartListContainer">
        <div className="space-y-6">
          {totalCart !== 0
            ? productList.map((product) => (
                <ShowCart key={product.id} product={product} />
              ))
            : "No product has been added to the cart."}
        </div>
        <ShowBill />
      </div>
    </div>
  );
}
